import stripeService from '../../services/stripeService'
import { Stripe, StripeElements } from '@stripe/stripe-js'

class SubscribeForm {
  onSubmitNewCard = async ({
    elements,
    stripe,
    referralId,
    promotionalCode,
  }: {
    elements: StripeElements
    stripe: Stripe
    referralId?: string
    promotionalCode?: string
  }): Promise<{
    intentType: 'payment' | 'setup'
    status: Awaited<ReturnType<typeof stripeService.subscribe>>['status']
    clientSecret: string
  }> => {
    const { error: submitError } = await elements.submit()
    if (submitError) {
      throw submitError
    }
    const { error: createPaymentMethodError, paymentMethod } = await stripe.createPaymentMethod({
      elements,
    })
    if (createPaymentMethodError) {
      throw createPaymentMethodError
    }
    const { intentType, status, clientSecret } = await stripeService.subscribe({
      paymentMethodId: paymentMethod.id,
      referralId,
      promotionalCode,
    })
    if (!clientSecret) {
      throw new Error('Something may have gone wrong. Please refresh the page.')
    }
    if (status === 'requires_action') {
      // Use Stripe.js to handle the required next action
      const { error: handleNextActionError } = await stripe.handleNextAction({
        clientSecret,
      })
      if (handleNextActionError) {
        throw handleNextActionError
      }
    }
    if (
      status === 'canceled' ||
      status === 'requires_payment_method' ||
      status === 'requires_confirmation'
    ) {
      throw new Error('Something may have gone wrong. Please refresh the page.')
    }
    return { intentType, status, clientSecret }
  }
  onSubmitExistingPaymentMethod = async ({
    paymentMethodId,
    stripe,
  }: {
    paymentMethodId: string
    stripe: Stripe
  }): Promise<{
    intentType: 'payment' | 'setup'
    status: Awaited<ReturnType<typeof stripeService.subscribe>>['status']
    clientSecret: string | null
  }> => {
    const { intentType, status, clientSecret } = await stripeService.subscribe({
      paymentMethodId,
    })
    if (status === 'requires_action') {
      if (!clientSecret) {
        throw new Error('Something may have gone wrong. Please refresh the page.')
      }
      // Use Stripe.js to handle the required next action
      const { error: handleNextActionError } = await stripe.handleNextAction({
        clientSecret,
      })
      if (handleNextActionError) {
        throw handleNextActionError
      }
    }
    if (
      status === 'canceled' ||
      status === 'requires_payment_method' ||
      status === 'requires_confirmation' ||
      status === 'requires_capture'
    ) {
      throw new Error('Something may have gone wrong. Please refresh the page.')
    }
    return { intentType, status, clientSecret }
  }
}

export default new SubscribeForm()
